// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__QitVN","form":"Login_form__UohUC"};